export default __webpack_public_path__ + "static/heroSectionImg-f932f367e3e289d8d6957d1b56295635.webp";